<template>
  <div>
    <TopHeader headerTitle="我的礼包" :isShowMenuIcon="false" />
    <Scroll ref="scroll" :class="$style.wrapper" :pullup="true" @bsPullingUp="bsPullingUp">
      <div :class="$style.box">
        <div
          v-for="item of myGiftList"
          :key="getGiftRecordKey(item)"
          :class="[
            $style['gift-item'],
            { [$style['external-gift-item']]: hasExternalGiftContent(item) }
          ]"
        >
          <img :src="item.icon" @click="openGiftDetails(item)" />
          <section :class="$style.info" @click="openGiftDetails(item)">
            <p>
              {{ item.title }}
              <img v-if="item.type == 1" :src="vipIcon" width="21px" />
              <img v-else :src="commonIcon" width="21px" />
            </p>
            <p v-if="item.type === 1">
              <span>{{ '领取时间:' }}</span>
              {{ formatDate(item.used_time) }}
            </p>
            <p v-if="item.type === 2">
              <span>{{ item.state ? '' : '失效时间:' }}</span>
              {{ item.state || formatDate(item.failure_time) }}
            </p>
            <div :style="{ opacity: item.type === 2 ? 1 : 0 }">
              <span>礼包码：</span>
              <input :value="item.code" readonly="readonly" />
            </div>
            <p v-if="hasExternalGiftContent(item)" :class="$style['gift-content']">
              <span>礼包内容：</span>{{ item.gift_content }}
            </p>
          </section>
          <div v-if="item.type === 2 && !item.state" :class="$style.btn">
            <button class="copyBtn" :data-clipboard-text="item.code">复制</button>
          </div>
        </div>
        <div ref="tips" :class="$style.nomore">
          <p v-if="noMore">—— 没有更多礼包了 ——</p>
        </div>
      </div>
    </Scroll>
  </div>
</template>

<script>
import TopHeader from '_c/TopHeader';
import Scroll from '_c/Scroll';
import { Toast } from "vant";
import { getMyGiftList } from '@/api/giftCenter';
import { CDN_URL } from "@/config/index.js";
import Clipboard from "clipboard";
import dayjs from 'dayjs'
import { mapActions, mapState, mapMutations } from 'vuex';

const EXTERNAL_GIFT_SOURCE = 'external';

export default {
  components: {
    TopHeader,
    Toast,
    Scroll
  },
  data() {
    return {
      commonIcon: `${CDN_URL}/gift_center/all.png`,
      vipIcon: `${CDN_URL}/gift_center/VIP.png`,
      title: '我的礼包',
      myGiftList: [],
      currentPage: 1,
      total: 0, // 列表总数
      noMore: false,
      externalSnapshotId: null,
    };
  },
  created() {
    this.getMyGiftList()
  },
  mounted() {
    this.copyInit();
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING'
    }),
    async getMyGiftList() {
      this.CHANGE_SHOW_LOADING(true)
      try {
        if (this.currentPage === 1) {
          this.externalSnapshotId = null;
        }
        const params = { page: this.currentPage, limit: 10 };
        if (this.currentPage > 1) {
          params.external_snapshot_id = this.externalSnapshotId;
        }
        const r = await getMyGiftList(params)
        this.total = r.data.total;
        if (this.currentPage == 1) {
          this.myGiftList = [...[]]
          this.noMore = false;
        }
        this.externalSnapshotId = r.data.external_snapshot_id;
        const nextGiftList = this.myGiftList.concat([...r.data.data]);
        this.validateGiftRecordKeys(nextGiftList);
        this.myGiftList = nextGiftList;
      } catch (error) {
        if (this.currentPage > 1) {
          this.currentPage--;
        }
        console.error(error);
        Toast.fail('礼包列表加载失败，请稍后重试');
      } finally {
        this.CHANGE_SHOW_LOADING(false)
        setTimeout(() => {
          this.$refs.scroll && this.$refs.scroll.refresh();
        }, 10);
      }
    },
    copyInit() {
      this.copy = new Clipboard(".copyBtn");
      this.copy.on("success", e => {
        Toast("复制成功");
        e.clearSelection();
      });
    },
    // 路由跳转
    handleLinkTo(name, query) {
      this.$router.push({ name, query })
    },
    getGiftRecordKey(item) {
      return this.isExternalGift(item) ? item.record_key : `local:${item.id}`;
    },
    isExternalGift(item) {
      return item.record_source === EXTERNAL_GIFT_SOURCE;
    },
    validateGiftRecordKeys(giftList) {
      const recordKeys = new Set();
      giftList.forEach(item => {
        const isMissingKey = this.isExternalGift(item)
          ? !item.record_key
          : item.id === undefined || item.id === null;
        const recordKey = this.getGiftRecordKey(item);
        if (isMissingKey || recordKeys.has(recordKey)) {
          throw new Error('礼包列表记录缺少或重复唯一标识');
        }
        recordKeys.add(recordKey);
      });
    },
    hasExternalGiftContent(item) {
      return this.isExternalGift(item) && Boolean(item.gift_content);
    },
    openGiftDetails(item) {
      if (this.isExternalGift(item)) {
        return;
      }
      this.handleLinkTo('giftCenter.details', { giftId: item.gift_set_id });
    },
    formatDate(date) {
      return dayjs(date).format('YYYY年MM月D日')
    },
    // 下拉加载
    bsPullingUp() {
      if (this.myGiftList.length >= this.total) {
        this.noMore = true
        return
      }
      this.currentPage++
      setTimeout(() => {
        this.getMyGiftList()
      }, 10);
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
@import '~@/styles/variable.scss';
.wrapper {
  height: calc(100vh - 94px);
  background-color: #efefef;
}
.box {
  padding-top: 3px;
  padding-bottom: 10px;
  width: 100vw;
  height: auto;
  .gift-item {
    margin: auto;
    margin-top: 7px;
    padding: 12px 17px 12px 17px;
    width: 361px;
    height: 76px !important;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    display: flex;
    align-items: center;
    > img {
      margin-top: -6px;
      width: 45px;
      margin-right: 7px;
      border-radius: 12px;
    }
    .info {
      width: 218px;
      p:first-of-type {
        font-size: 11px;
        line-height: 12.5px;
      }
      p:nth-of-type(2) {
        @include ellipsis(1);
        margin-top: 4px;
        font-size: 10px;
        color: #9f9f9f;
      }
      div {
        padding: 0px 3.5px 0px 3.5px;
        margin-top: 6px;
        margin-left: -4px;
        width: 149px;
        height: 18px;
        line-height: 18px;
        font-size: 10px;
        border-radius: 10px;
        background-color: #f3f3f3;
        > span {
          display: inline-block;
          margin-right: 2px;
          height: 18px;
          line-height: 18px;
          color: #ff7e30;
        }
        > input {
          @include clearBtnDefaultStyle;
          @include ellipsis(1);
          width: 90px;
          height: 18px;
          line-height: 18px;
          display: inline-block;
          color: #9f9f9f;
        }
      }
      .gift-content {
        margin-top: 5px;
        font-size: 10px;
        line-height: 12px;
        color: #9f9f9f;
        word-break: break-all;
        > span {
          color: #ff7e30;
        }
      }
    }
    .btn {
      button {
        @include clearBtnDefaultStyle;
        margin-left: 10px;
        width: $buttonWidth;
        height: $buttonHeight;
        color: #fff;
        font-size: 10px;
        background-color: $buttonColor;
        border-radius: 15px;
      }
    }
  }
  .external-gift-item {
    min-height: 100px;
    height: auto !important;
  }
  .nomore {
    height: 50px;
    line-height: 50px;
    font-size: 12px;
    text-align: center;
    color: rgba(159, 159, 159, 1);
  }
}
</style>
